import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "7.5",
      cy: "12.5",
      r: "7.5",
      fill: "#EA001B"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "16.5",
      cy: "12.5",
      r: "7.5",
      fill: "#F8AA33"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FF5F01",
      "fill-rule": "evenodd",
      d: "M12 18.5a7.49 7.49 0 0 0 3-6 7.49 7.49 0 0 0-3-6 7.49 7.49 0 0 0-3 6 7.49 7.49 0 0 0 3 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }